import { useCallback } from 'react';
import useWaProductRepo from '../repository/WaProductRepo';
import { useWaProductStore } from '../store/WaProductStore';
import { useWaDisasterStore } from '../store/WaRegionAndDisasterStore';
import { Workplace } from '../store/models/workplace';
import { WaProduct } from '../store/models/product/WaProduct';

function useWaProductService() {
  const { getProductsRequest, getProductDetailsRequest } = useWaProductRepo();
  const { selectedDisaster } = useWaDisasterStore();
  const { setProducts, setProductDetails, setProductMasterInfo } = useWaProductStore();

  const fetchProducts = useCallback(
    async (selectedWorkplace: Workplace) => {
      if (!selectedDisaster) return;

      const { customerId, branchCode } = selectedWorkplace;

      try {
        const products = await getProductsRequest(customerId, branchCode, selectedDisaster.id);
        const sortedProducts = [...products].sort((a, b) =>
          a.productNumber.localeCompare(b.productNumber)
        );
        setProducts(sortedProducts);
      } catch (error) {
        console.log(error);
        setProducts([]);
      }
    },
    [getProductsRequest, selectedDisaster, setProducts]
  );

  const fetchProductMasterInfo = useCallback(
    async (selectedWorkplace: Workplace) => {
      if (!selectedDisaster) return;

      const { customerId, branchCode } = selectedWorkplace;

      try {
        const products = await getProductsRequest(customerId, branchCode, null);
        const sortedProducts = [...products].sort((a, b) =>
          a.productNumber.localeCompare(b.productNumber)
        );
        setProductMasterInfo(sortedProducts);
      } catch (error) {
        console.log(error);
        setProductMasterInfo([]);
      }
    },
    [getProductsRequest, selectedDisaster, setProductMasterInfo]
  );

  const fetchProductDetails = useCallback(
    async (selectedProduct: WaProduct, selectedWorkplace: Workplace) => {
      if (!selectedDisaster) return;

      const { branchCode } = selectedWorkplace;
      const { productNumber } = selectedProduct;

      try {
        const productDetails = await getProductDetailsRequest(
          branchCode,
          productNumber,
          selectedDisaster.id
        );

        setProductDetails(productDetails);
      } catch (error) {
        console.log(error);
      }
    },
    [getProductDetailsRequest, selectedDisaster, setProductDetails]
  );

  const fetchProductMasterDetails = useCallback(
    async (selectedProduct: WaProduct, selectedWorkplace: Workplace) => {
      const { branchCode } = selectedWorkplace;
      const { productNumber } = selectedProduct;

      try {
        const productDetails = await getProductDetailsRequest(branchCode, productNumber, null);

        setProductDetails(productDetails);
      } catch (error) {
        console.log(error);
      }
    },
    [getProductDetailsRequest, setProductDetails]
  );

  return { fetchProducts, fetchProductDetails, fetchProductMasterInfo, fetchProductMasterDetails };
}

export default useWaProductService;
